export default "__VITE_ASSET__CJAs1$7R__"